export class WorkflowCountData {
    public workflowId: number;
    public workflowName: string;

    public formInstanceTotalCount: number;
    public folderTotalCount: number;
}
